import { useFetch } from "../../hooks/useFetch";
import { Loading, EmptyState } from "../../components/States";
import { JobCard } from "../../components/JobCard";
import { CalendarDays } from "lucide-react";

export default function FieldSchedule() {
  const { data, loading } = useFetch("/dashboard/field");
  if (loading || !data) return <Loading />;
  const all = [...data.today, ...data.upcoming];

  const byDay = {};
  all.forEach((j) => {
    const d = new Date(j.scheduled_date).toLocaleDateString([], { weekday: "long", month: "short", day: "numeric" });
    (byDay[d] = byDay[d] || []).push(j);
  });

  return (
    <div className="space-y-6">
      <h1 className="font-head text-4xl font-black text-white">Schedule</h1>
      {all.length === 0 ? (
        <EmptyState title="Nothing scheduled" icon={CalendarDays} />
      ) : (
        Object.entries(byDay).map(([day, jobs]) => (
          <div key={day}>
            <div className="hw-eyebrow mb-3 flex items-center gap-2"><CalendarDays size={14} /> {day}</div>
            <div className="space-y-4">{jobs.map((j) => <JobCard key={j.id} job={j} />)}</div>
          </div>
        ))
      )}
    </div>
  );
}
